export enum ModuleEnum {
    Base = 1,
    Complaint,
    Prevention,
}

export enum ClientStatusPrevention {
    NoHIVStatus = 1,
    HIVStatusConfirmedFromClientsWords,
    HIVStatusConfirmedCaseManagement,
    HIVStatusConfirmedFromMIS,
    HIVStatusConfirmedRapidTest,
    HIVStatusFalsePositive,
}

export enum OrgRoles {
    Donor = 1,
    Recipient,
    SubRecipient,
    ExternalOrganizations,
    ServiceDeliveryPoint,
    MedicalOrganization = 8,
    DKVS,
}

export enum DIPClientCategory {
    NoCategory = 1,
    InjectionDrugs = 2,
    CommercialSex = 3,
    Prisoner = 4,
    NonInjectionDrugs = 5,
    ManWhoHasSexWithMen = 6,
    NoPermanentResidence = 7,
    Migrant = 8,
    SexualPartners = 10,
    Transgender = 11,
    Military = 12,
    TBContact = 13,
    HarmfulWorkingConditions = 14,
    MedicalWorkers = 15,
    ConcomitantDiseases = 16,
    AlcoholAbuse = 17,
    BelowPovertyLine = 18,
    ReleasedFromPenitentiary = 19,
    CivilDefense = 20,
    MilitaryPartners = 21,
    GenderViolence = 22,
    InjectionPartnerHIV = 23,
    InjectionDrugsSexualPartner = 24,
    CommercialSexClient = 25,
    MSMSexualPartner = 26,
    MigrantsKids = 27,
}

export enum ClientCategoryEnum {
    NoCategory = 1,
    InjectionDrugs = 2,
    ManWhoHasSexWithMen = 6,
    CommercialSex = 3,
    Transgender = 11,
    InjectionPartnerHIV = 23,
    SexualPartners = 10,
    NonInjectionDrugs = 5,
    Prisoner = 4,
    NoPermanentResidence = 7,
    InternallyMovedPerson = 9,
    Migrant = 8,
    CivilDefense = 20,
    Military = 12,
    MilitaryPartners = 21,
    GenderViolence = 22,
    ReleasedFromPenitentiary = 19,
    AlcoholAbuse = 17,
    TBContact = 13,
    MedicalWorkers = 15,
    BelowPovertyLine = 18,
    ConcomitantDiseases = 16,
    HarmfulWorkingConditions = 14,
}

export enum FunctionalStatusEnum {
    AbleToWork = 1,
    AbleSelfService,
    NeedsHelp,
    Unknown,
}

export enum DisabilityGroupEnum {
    Group1 = 1,
    Group2,
    Group3,
    DisabledChild,
    Empty,
    NeedForReRegistration,
    Unknown,
}

export enum SocialHelpEnum {
    HelpingHIVChild = 1,
    LowIncomeFamily,
    Subsidy,
    Pregnancy,
    Childbirth,
    ThreeYears,
    Pension,
    Custody,
    NotReceive,
    Need,
    Other,
    Unknown,
    SingleMothersChildSupport,
}

export enum ClientRightsProtectionEnum {
    ViolationOfRights = 1,
    RightsNotViolated,
    Unknown,
}

export enum EducationLevelPrevention {
    IncompleteGeneral = 1,
    SecondarySpecialized,
    CompleteSecondary,
    UnfinishedHigher,
    Postgraduate,
    Doctorate,
}

export enum SocialStatus {
    PermanentJob = 1,
    Unemployed,
    TemporaryWork,
    Student,
    Retired,
}

export enum DrugUseFrequency {
    SeveralTimesDay = 1,
    OnceAday,
    SeveralTimesWeek,
    SeveralTimesMonth,
    SeveralTimesYear,
}

export enum DrugUseMethod {
    Injectable = 1,
    SmokingInhalation,
    Oral,
    Intranasal,
    Other,
}

export enum SexualPartnersNumber {
    One = 1,
    More,
}

export enum CondomUseFrequency {
    One = 1,
    Occasionally,
    Sometimes,
}

export enum CondomDuringLastContact {
    Yes = 1,
    No,
    DontKnow,
}

export enum TestsResult {
    PositiveFromWords = 1,
    Negative,
}

export enum IdentityDocumentsEnum {
    Available = 1,
    Missing,
    Unknown,
}

export enum ClientTypeEnum {
    Negative = 1,
    Positive,
    Unspecified,
    RemovedStatus,
}

export enum CommunicationTypeEnum {
    HomePhone = 1,
    WorkPhone,
    OtherPhone,
    Email,
    MainPhone,
}

export enum EducationLevelEnum {
    BasicSecondary = 1,
    UpperSecondary = 2,
    Technical = 3,
    HigherFull = 5,
    GeneralEducation = 6,
    NotOrganizedChildhood = 7,
    Unknown = 8,
    ProfessionalPreHigher = 9,
    DoesNotApply = 10,
}

export enum EmploymentEnum {
    Working = 1,
    Unemployed,
    Learns,
    Housewife,
    Pensioner,
    DoesNotApply,
    Unknown,
}

export enum GenderEnum {
    Male = 1,
    Female,
}

export enum WarehouseTypeEnum {
    Organization = 1,
    SocialWorker,
}

export enum WorksheetStatusEnum {
    Open = 1,
    Closed = 2,
    Cancelled = 3,
}

export enum TicketNumberEnum {
    one = 1,
    two,
    three,
    four,
    threeandtwo,
}

export enum MovementTypeEnum {
    Supply = 1,
    Movement,
    Issue,
    WriteOff,
    Adjustment,
}

export enum BooleanEnum {
    true = 'true',
    false = 'false',
}

export enum MovementStatusEnum {
    Draft = 1,
    InProgress,
    Correction,
    Completed,
    ChangesConfirmed,
    Cancelled,
}

export enum OwnerTypeForStockItemFilter {
    All = 1,
    MyOrganization,
    AllConsultantsOfMyOrganization,
}

export enum ServiceRouteTypeEnum {
    StationaryPoint = 1,
    StreetRoute,
    MobileAmbulatory,
}

export enum IdentDocTypeEnum {
    Passport = 1,
    PensionerCertificate = 2,
    BirthCertificate = 3,
    DriverLicense = 4,
    biopassport = 5,
    TEMPORARY_RESIDENCE_PERMIT = 6,
    TEMPORARY_CERTIFICATE = 7,
    SSN = 8,
    REFUGEE_CERTIFICATE = 9,
    PERMANENT_RESIDENCE_PERMIT = 10,
    COMPLEMENTARY_PROTECTION_CERTIFICATE = 11,
    ChernobylLiquidatorCat2 = 12,
    ChernobylLiquidatorCat3 = 13,
    ChernobylVictimAdult1 = 14,
    ChernobylVictimAdult2 = 15,
    ChildChernobylVictim = 16,
    ChernobylLiquidatorCat1 = 17,
    ChernobylVictimAdult3 = 18,
    TEMPORARY_PASSPORT = 19,
}

export enum MaritalStatusEnum {
    Single = 1,
    Other = 2,
    Separated = 3,
    Widow = 4,
    Married = 5,
    Unknown,
    NotApplicable,
}

export enum MaritalStatusPrevention {
    Married = 1,
    Single = 2,
    Divorced = 3,
    Widow = 4,
    Roommate,
}

export enum ProjectRoleEnum {
    Donor = 1,
    Recipient,
    SubRecipient,
    ExternalOrganizations,
    ServiceDeliveryPoint,
    MedicalOrganization = 8,
    DKVS,
}

export enum TreatmentARTsTypeEnum {
    Prescription = 1,
    Change,
    Replacement,
    Interruption,
    Stop,
    CD,
    VN,
    CommitmentLevel,
}

export enum ProjectStateEnum {
    New = <any>1,
    InProcess = <any>2,
    Completed = <any>3,
}

export enum ResultTypeEnum {
    None = <any>1,
    YesNo = <any>2,
    Numeric = <any>3,
    YesNoUnknown = <any>4,
    YesNoInvalid = <any>5,
}

export enum UserRoleEnum {
    Admin = 1,
    AdminDonor,
    AdminRecipient,
    AdminSubRecipient,
    Consultant,
    Root,
    Client,
    Integration,
    AdminSubRecipientPlus = 11,
}

export enum TwoFactorType {
    IdGov = 1,
    EmailCode = 2,
}

export enum VerificationTypeEnum {
    App = 1,
    SMS,
    VerificationNotRequired,
    VerificationByAdmin,
    Call,
    AdminCreated,
    AppQrCode,
}

export enum PartnerTypeEnum {
    Child = 1,
    Injection,
    Sexual,
}

export enum PartnerInfoEnum {
    InformingClient = 1,
    InformingDoctor,
    ContractInforming,
    InformingDoctorAndClient,
    RiskToNSPP,
    PartnerHasPositiveStatus,
}

export enum ClientReasonForTestingEnum {
    PartnerSexual = 1,
    PartnerSyringe,
    TB,
    SkinDisease,
    OtherMedicalIndications,
    OtherNonMedicalIndications,
    SelfConversion,
    ChildOfHIVPositive,
    Other,
}

export enum ResultDictionaryEnum {
    Positive = 1,
    Negative,
    Unknown,
    Invalid,
}

export enum AppointmentStateEnum {
    New = 1,
    Started,
    Completed,
    Accepted,
    Rejected,
    CompletedUnferified,
    Canceled,
}

export enum SecondGenderEnum {
    Man = 1,
    Woman,
    Transman,
    Transwoman,
    NonbinaryPerson,
    OtherOption,
}

export enum LegalAssistanceEnum {
    First = 1,
    Second,
}

export enum InvolvementMethod {
    Self = 1,
    RedirectedFromMedicalWorker,
    Repeat,
    SocialWorkerHelp,
    RedirectedFromPreventionPrograms,
}

export enum PregnancyResult {
    Childbirth = 1,
    SpontaneousAbortion,
    ArtificialAbortion,
}

export enum HepatitisOperType {
    HepatitisBExamination = 1,
    HepatitisBVaccination,
    HepatitisCExamination,
    HepatitisCTreatment,
}

export enum HepatitisBExaminationType {
    HepatitisBSurfaceAntigen = 1,
    AntibodiesToHepatitisBBuclearAntigen,
    HepatitisBPCR,
}

export enum HepatitisBVaccinationDose {
    OneDose = 1,
    SecondDose,
    ThirdDose,
}

export enum HepatitisCExaminationType {
    HCVAntibodyTesting = 1,
    HCVRNATestStart,
    Genotype,
    LiverDamageStage,
    HBsAg,
    ALTLevels,
    ACTLevels,
    HCVRNATestEnd,
}

export enum HepatitisCExaminationGenotypeResult {
    OneA = 1,
    OneB,
    Two,
    Three,
    Four,
    Five,
    Six,
}

export enum HepatitisCExaminationLiverDamageStage {
    F0 = 1,
    F1,
    F2,
    F3,
    F4,
}

export enum HepatitisCSupportEffectiveness {
    FullCourseCompleted = 1,
    SeparationFromTreatment,
    Died,
    RefusalOfSupport,
    Moved,
}

export enum HepatitisCTreatmentResult {
    Healed = 1,
    TreatmentFailure,
    Died,
    NoInformation,
    Moved,
}

export enum HepatitisBVaccine {
    Engerix = 1,
    EUVAX,
    Twinrix,
}

export enum PeriodStatus {
    Open = 1,
    Closed,
}

export enum TuberculosisOperType {
    Screening = 1,
    Diagnosis,
    Treatment,
    Chemoprophylaxis,
}

export enum ScreeningResult {
    Suspicion = 1,
    NoSuspicion,
}

export enum DiagnosticMethod {
    GeneXpert = 1,
    SputumAnalysis,
    Biopsy,
    CT,
    MRI,
    PCR,
    Radiological,
    Bacterioscopic,
    Bacteriological,
    IGRA,
}

export enum SecuritySettingValueType {
    Integer = 1,
    Boolean,
    Text,
}

export enum DiagnosticResult {
    EstablishedDiagnosis = 1,
    NotConfirmed,
    InWork,
}

export enum TBTreatmentCategory {
    One = 1,
    Two,
    Three,
    Four,
}

export enum RadiologicalResult {
    NotDone = 1,
    PositiveDynamics,
    NegativeDynamics,
    Unchanged,
    Stabilization,
}

export enum TBTreatmentResult {
    Cured = 1,
    TreatmentIsComplete,
    Died,
    UnsuccessfulTreatment,
    InterruptedTreatment,
    RemovedDiagnosis,
    Moved,
    SupportRefusal,
    NotEvaluatedResult,
}

export enum ChemoprophylaxisSupportEffectiveness {
    FullTreatmentCcoursCompleted = 1,
    TreatmentRefusal,
    Died,
    SupportRefusal,
    MovedToOtherOrg,
}

export enum SpecialRootsEnum {
    ViewAppointmentByContract = 1,
    CreateConsultant,
    MergeClients,
    PaidService,
}

export enum TimePeriodEnum {
    Day = 1,
    Week,
    Month,
    Quarter,
    HalfYear,
    Year,
}

export enum TimeTableType {
    Schedule = 1,
    Exclusion,
}

export enum ExclusionType {
    Dinner = 1,
    SickLeave,
    Vacation,
}

export enum RepetitionConfiguration {
    Daily = 1,
    Even,
    NotEven,
    DaysOfTheWeek,
}

export enum DayOfWeek {
    Monday = 1,
    Tuesday,
    Wednesday,
    Thursday,
    Friday,
    Saturday,
    Sunday,
}

export enum OperationType {
    Added = 'Added',
    Modified = 'Modified',
    Deleted = 'Deleted',
}

export enum NotificationType {
    Informational = 1,
    Critical = 2,
}

export enum NotificationSendMode {
    Immediately = 1,
    Scheduled = 2,
}

export enum NotificationPeriodicity {
    Once = 1,
    Daily = 2,
    Weekly = 3,
    Monthly = 4,
}

export enum NotificationCondition {
    HasUnbundledClients = 1,
}

export enum NotificationDispatchStatus {
    Planned = 1,
    Processing = 2,
    Sent = 3,
    Failed = 4,
    Skipped = 5,
    Cancelled = 6,
}

export enum MyNotificationsFilter {
    All = 1,
    New = 2,
    Read = 3,
}

export enum QrTokenType {
    Identify = 1,
    ConfirmAppointment = 2,
}

export enum QrScanResult {
    Success = 1,
    NotFound = 2,
    Expired = 3,
    AlreadyUsed = 4,
    WrongPerson = 5,
    RateLimited = 6,
}
